import _ from "lodash";
import React, { forwardRef, memo } from "react";
import classes from "./DraggableRow.scss";
import PropTypes from "prop-types";
import classNames from "classnames";
import TableCell from "../DraggableCell/TableCell";

// Row Component
const TableRow = forwardRef(
  (
    {
      row,
      setCellValue,
      mode,
      rowIndex,
      setShowColumnOptions,
      showRowOptions,
      showColumnOptions,
      editorToolbarOptions,
      testId,
      tableRowStyles,
      columnListenersAndAttrRefObj,
      isRowDragging,
      isLastRow,
      setShowRowOptions,
      onFocusInputCell,
      onBlurInputCell,
      resizingColumnId,
    },
    ref
  ) => {
    const rowId = _.get(row, "id");

    const tableRowClasses = classNames({
      [classes.rowActive]: _.isEqual(rowId, showRowOptions),
      [classes.lastRowActive]: isRowDragging,
    });

    return (
      <tr
        ref={ref}
        style={tableRowStyles}
        className={tableRowClasses}
        id={`Row_${rowId}`}
      >
        {row.getVisibleCells().map((cell, colIndex) => {
          return (
            <TableCell
              key={cell.id}
              cell={cell}
              setCellValue={setCellValue}
              mode={mode}
              colIndex={colIndex}
              rowIndex={rowIndex}
              setShowColumnOptions={setShowColumnOptions}
              showColumnOptions={showColumnOptions}
              editorToolbarOptions={editorToolbarOptions}
              testId={testId}
              columnListenersAndAttrRefObj={columnListenersAndAttrRefObj}
              isLastRow={isLastRow}
              setShowRowOptions={setShowRowOptions}
              onFocusInputCell={onFocusInputCell}
              onBlurInputCell={onBlurInputCell}
              resizingColumnId={resizingColumnId}
            />
          );
        })}
      </tr>
    );
  }
);

TableRow.defaultProps = {
  tableRowStyles: {},
  isRowDragging: false,
  isLastRow: false,
};

TableRow.propTypes = {
  tableRowStyles: PropTypes.object,
  isRowDragging: PropTypes.bool,
  isLastRow: PropTypes.bool,
};

TableRow.displayName = "TableRow";

export default memo(TableRow);
